import type { FC } from 'react';
import classnames from 'classnames';
import { useAuthContext } from '@r-and-a-shared-ui/auth-client';
import styles from './SSOButtons.module.scss';
import { RenderOn } from '../lib/RenderOn/RenderOn';
import { sendGTMEvent } from '@next/third-parties/google';
import { getPageTrackingDetails } from '@r-and-a-shared-ui/utils';

export const SSOSignOutButton: FC = () => {
  const {
    methods: { federatedSignOut },
    userState: { isAuthenticated },
  } = useAuthContext();

  const handleClick = () => {
    sendGTMEvent({ event: 'log_out_click', value: getPageTrackingDetails() });
    federatedSignOut();
  };

  return (
    <RenderOn condition={isAuthenticated} key={'sign-out-button'}>
      <span
        onClick={handleClick}
        data-testid={'RestrictedContentLogoutButton'}
        className={classnames(styles.btn, styles['btn--primary'])}
      >
        Sign Out
      </span>
    </RenderOn>
  );
};
